import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://beyondballindia.com';

const SEO = ({ title, description, path = '/', image }) => {
  const fullTitle = title.includes('Beyond Ball India') ? title : `${title} | Beyond Ball India`;
  const url = `${SITE_URL}${path}`;
  // og:image must be an absolute URL (social scrapers won't resolve relative paths).
  // Prefer the same-origin logo hosted at /brand-logo.png so browsers with strict
  // third-party asset blocking (Brave Shields, etc.) don't drop it.
  const ogImage = image || `${SITE_URL}/brand-logo.png`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEO;
